import { v4 as uuidv4 } from 'uuid';

const defaultRessource = {
    "video": {
        idSoft: uuidv4(),
        name: "@video@",
        description: "[DEBUG] video",
        url: "assets/videos/mov_bbb.mp4",
    },
    "image": {
        idSoft: uuidv4(),
        name: "@background@",
        description: "[DEBUG] image",
        url: "assets/images/background.png",
    },
    "font": {
        idSoft: uuidv4(),
        name: "@Arial@",
        description: "Arial",
        url: "assets/fonts/ARIAL.TTF",
    },
    "text": {
        idSoft: uuidv4(),
        name: "@text@",
        desc: "[DEBUG] text",
        text: "Hello World",
    }
};
export default defaultRessource;